/* eslint-disable @reatom/unit-naming-rule */
import { fetchHoldersRequestAction } from '@root/features/trade/holders'
import { fetchTopTradersRequestAction } from '@root/features/trade/top-traders'
import { reatomResource } from '@root/shared/lib'

import type { Network } from '@root/entities/network'
import type { PairAddress } from '@root/entities/pair'

/**
 * Who holds this token, and who has made money on it.
 *
 * Two reads of the same shape — a ranked list of wallets with what each of
 * them bought, sold and is left holding. They are here rather than behind the
 * app's table framework because what this screen wants is a list, not a
 * spreadsheet: no sorting, no cursor, one page of the ones that matter.
 *
 * Neither read takes a limit — the server decides how many it is worth
 * sending, which for a token's holders is the right side to decide it on.
 */
export type HoldersResource = ReturnType<typeof reatomPairHolders>

export const reatomPairHolders = ({
  pairAddress,
  network,
}: {
  pairAddress: PairAddress
  network: Network.Network
}) =>
  reatomResource(
    async (ctx) =>
      ctx.schedule(() =>
        fetchHoldersRequestAction(ctx, { pairAddress, network }),
      ),
    { name: 'reatomPairHolders', loadOnConnect: true },
  )

export const reatomPairTopTraders = ({
  pairAddress,
  network,
}: {
  pairAddress: PairAddress
  network: Network.Network
}) =>
  reatomResource(
    async (ctx) =>
      ctx.schedule(() =>
        fetchTopTradersRequestAction(ctx, { pairAddress, network }),
      ),
    { name: 'reatomPairTopTraders', loadOnConnect: true },
  )
